import React, { ReactNode } from 'react';
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Dialog, Typography } from '@material-ui/core';

type Props = {
    open: boolean,
    title: string,
    contentText: string,
    warningText?: string,
    handleYes: () => void,
    handleNo: () => void,
    loading?: boolean,
    loadingText?: ReactNode
}

export const ConfirmationDialog : React.FC<Props> = ({open, title, loading = false, loadingText = "", contentText, warningText = "", handleNo, handleYes}) => {

    const handleDialogClose = (_: any, reason: string) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleNo();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {loading &&
                        <Typography variant='h3' style={{minWidth: 300}}>{loadingText}</Typography>
                    }
                    {!loading &&
                        <Typography>{contentText}</Typography>
                    }
                    {!loading &&
                        <Typography color='error'>{warningText}</Typography>
                    }
                </DialogContentText>
            </DialogContent>
            {loading === false &&
            <DialogActions>
                <Button variant='contained' size='small' color='primary' disabled={loading} onClick={() => handleYes()}>
                    Yes
                </Button>
                <Button variant='contained' size='small' disabled={loading} onClick={() => handleNo()}  autoFocus>
                    No
                </Button>
            </DialogActions>
            }
        </Dialog>
    )

}
